module.exports = __webpack_public_path__ + "static/media/logo-grey.1d033414.svg";